import { HD_GATE_LOVE_GATES } from '../bodygraph/hd-gate-categories';

/**
 * Metadata van de liefdespoorten (Love gates cheat sheet, Figma 1732-8232),
 * voor het love-gates-paneel, de klikbare love-iconen en de
 * connectiviteitspoorten-sectie bij composite-charts. De poortlijst is de
 * love-categorie ({@link HD_GATE_LOVE_GATES}): 10, 15, 25, 28, 40, 41, 44, 46,
 * 55, 58 — poort 44 ("Succesvolle Liefde, talent") is 2026-09-25 aan de
 * categorie toegevoegd op basis van de cheat sheet (het icoon droeg hij al).
 */
export const HD_LOVE_GATES: readonly number[] = HD_GATE_LOVE_GATES;

/**
 * Leesvolgorde van de blokjes/secties, zoals de kaarten op het Figma-poster
 * (rij per rij, links → rechts): de Vessel of Love-poorten van het G-centrum
 * eerst, dan milt/hart/solar plexus/root.
 */
export const HD_LOVE_GATES_DISPLAY_ORDER: readonly number[] = [
  10, 25, 15, 46, 44, 40, 28, 55, 58, 41,
];

/** Bodygraph-fragmentenchart met de love-dots (uit het Figma-poster). */
export const HD_LOVE_CHART_ASSET = 'assets/human-design/love/love-gates-chart.png';

/** Mandala-ring met de gemarkeerde liefdespoorten (uit het Figma-poster). */
export const HD_LOVE_MANDALA_RING_ASSET = 'assets/human-design/love/love-gates-mandala-ring.png';

/** Is dit een liefdespoort (en dus een sectie in het paneel)? */
export function hdIsLoveGate(gate: number): boolean {
  return HD_LOVE_GATES.includes(gate);
}

/** Paneel-key van het love-gates-paneel (dedup in de FloatingPanelService). */
export const HD_LOVE_PANEL_KEY = 'love-gates';

/** `FLOATING_PANEL_DATA` van het love-gates-paneel. */
export interface HdLovePanelData {
  /** Poort waar het paneel na openen naartoe scrollt, of `null`. */
  readonly focusGate: number | null;
}

/**
 * Indicatorkleur per liefdespoort, 1:1 de kaartkleuren van het Figma-design
 * (node 1732-8232), gegroepeerd per centrum: G-poorten geel, milt-poorten
 * licht-oranje, solar plexus oranje, hart roze, root bruin.
 */
export const HD_LOVE_GATE_COLOR: Readonly<Record<number, string>> = {
  10: '#f7ffa4', 15: '#f7ffa4', 25: '#f7ffa4', 46: '#f7ffa4',
  44: '#fac884', 28: '#fac884',
  55: '#ffa14e',
  40: '#ff8c8e',
  58: '#cbaa7c', 41: '#cbaa7c',
};

/** Fallback-railkleur (deck-harttint) zolang er geen Figma-kleur per poort is. */
export const HD_LOVE_FALLBACK_COLOR = '#F58E94';
